import { Box, IconButton } from '@youversion/design-system-components';
import Spinner from '@youversion/design-system-icons/lib/Spinner';
import TrashCan from '@youversion/design-system-icons/lib/TrashCan';
import React from 'react';

interface Props {
  children: React.ReactNode;
  editing: boolean;
  loading?: boolean;
  onClick: () => void;
  onEdit?: () => void;
  selected: boolean;
  testId?: string;
  value: number | string;
}

const inputClasses = `
  w-[20px] h-[20px] mie-0.5 flex-none cursor-pointer  appearance-none
bg-white outline checked:outline-offset-[-2px] checked:ring-offset-[-2px] outline-black outline-1 focus-visible:outline-0 rounded-full
checked:bg-blue-20 checked:outline-blue-30 checked:outline-2 checked:ring-2 checked:ring-blue-30`;

export default function PaymentMethodBox({ children, ...rest }: Props) {
  return (
    <Box
      borderRadius='rounded-1'
      className={`mbe-2 ${rest.selected ? 'bg-blue-10 dark:bg-blue-50' : 'bg-white dark:bg-canvas-secondary-dark'}`}
      width='w-full'
    >
      <label className='flex justify-between cursor-pointer plb-2 pli-2'>
        {children}
        <Box className='flex justify-center items-center'>
          <Input
            editing={rest.editing}
            loading={rest.loading}
            onClick={rest.onClick}
            onEdit={rest.onEdit}
            selected={rest.selected}
            testId={rest.testId}
            value={rest.value.toString()}
          />
        </Box>
      </label>
    </Box>
  );
}

interface InputProps {
  editing: boolean;
  loading?: boolean;
  onClick: () => void;
  onEdit?: () => void;
  selected: boolean;
  testId?: string;
  value: string;
}

const Input = ({ editing, onEdit, selected, onClick, value, testId, loading }: InputProps) => {
  if (editing && !onEdit) {
    return null;
  }

  if (loading) {
    return <Spinner className='animate-spin text-text-light dark:text-text-dark size-3' />;
  }

  return editing ? (
    <IconButton className='-mie-0.5' data-testid='delete-payment-method' onClick={onEdit} variant='borderless'>
      <TrashCan />
    </IconButton>
  ) : (
    <input
      checked={selected}
      className={inputClasses}
      data-testid={testId}
      name='paymentMethod'
      onClick={onClick}
      readOnly={true}
      type='radio'
      value={value}
    />
  );
};
